import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { PiHandshakeDuotone } from "react-icons/pi";

import sh_d_logo_nb from './../media/img/sh-d-logo-nb.png'
import sh_nd_logo_nb from './../media/img/sh-nd-logo-nb.png'
import gg1 from './../media/img/gg1.png'
import nft1 from './../media/img/nft1.png'
import nft2 from './../media/img/nft2.png'
import nft3 from './../media/img/nft3.jpg'

import sui_logo from './../media/img/sui-logo.png'
import sui_ai_logo from './../media/img/sui_ai_logo.webp'
import x_logo from './../media/img/x-logo.png'
import tg_logo from './../media/img/tg-logo.png'
import dex_logo from './../media/img/dex-logo.png'
import phantom_logo from './../media/img/phantom_logo.png'
import sol_logo from './../media/img/sol_logo.png'
import sui_wallet from './../media/img/suiwallet.png'
import sui_coin from './../media/img/suicoin.png'
import move_logo from './../media/img/move-logo.png'
import dex_s_logo from './../media/img/dex_s_logo.png'
import gk_logo from './../media/img/gk_logo.png'
import cg_logo from './../media/img/cg_logo.png'

import ton_logo from './../media/img/tn-logo-bg.png'
import ton_keeper_logo from './../media/img/tonkeeper_logo.png'
import { ReactComponent as BscLogo } from './../media/img/bscscan-logo.svg';

import x_icon from './../media/icons/x-icon.png'
import twitter_icon from './../media/icons/twitter-icon.jpg'
import tg from './../media/icons/tg-icon.png'

import com_icon from './../media/icons/com_icon.png'
import ama_icon from './../media/icons/ama_icon.png'
import inf_icon from './../media/icons/inf_icon.png'
import earn_icon from './../media/icons/earn_icon.png'
import check_icon from './../media/icons/check_icon.png'
import eq_icon from './../media/icons/eq_icon.png'
import lock_icon from './../media/icons/lock_icon.png'
import per_icon from './../media/icons/per_icon.png'
import copy_icon from './../media/icons/copy.png'

import mail_icon from './../media/icons/mail-icon.png'
import dex_icon from './../media/icons/dex-icon.png'

import { htws } from './../utilities/about-htw'
import { jeetcmds } from './../utilities/jeet-cmd'


const Home = () => {


    const [htwCount, setHtwcount] = useState(0)
    const [textca, setTextca] = useState("0x1f982433087ae18dcb9bbf4c13dcf504c1f9d63176cdfe9abc8447e31bbb77ba::lokai::LOKAI");
    const [warncompstatus, setwarncompstatus] = useState(true)

    const copyToClipboard = () => {
        navigator.clipboard
        .writeText(textca)
        .then(() => {
            alert("ca copied to clipboard!");
        })
        .catch((err) => {
            console.error("Failed to copy ca: ", err);
        });
    };

    const warningComp = () => (
        <div className={`warn-cont ${warncompstatus ? 'active' : ''}`}>

            <div className="warn-box">
                <div className="warn-box-inner">

                    <div className="flex justify-center">
                        <div className="lg">
                            <img src={sh_d_logo_nb} alt="" />
                        </div>
                    </div>

                    <h2>This is a hustler website</h2>

                    <p>
                        This website is only for those who want big money. By entering, you confirm that you're ready to buy 
                        a new lambo, a new mansion and escape the matrix. Join us on this exciting journey and take the first step towards your new life
                    </p>

                    <div className="warn-btn-box flex justify-space-between wrap">
                        <a href="https://movepump.com/token/0x361b655145465f6a8113f9fdca0ad01ff19b4ec31e0f0bf7514dba47d8e766db::shub::SHUB" className="warn-btn blue" target="_blank">
                            I want to get rich - Enter
                        </a>
                        <a className="warn-btn" onClick={() => setwarncompstatus(null)}>
                            I want to stay broke - Exit
                        </a>
                    </div>

                    <p>
                        The <a href="#">Rat Race</a> explain how you can easily block access <br /> to this site.
                    </p>

                    <div className="flex justify-center">
                        <div className="flex align-center gap-4">
                            <h6>© SuiHub on Sui</h6>
                            <div className="warn-cp-img">
                                <img src={sui_logo} alt="" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )



    return ( 
        <div className="">

            {/* {warncompstatus ? 
                <div className="backdrop"></div>
            : null} */}

            {warningComp()}

            <section className="exit-page" id="exit-page">
                <div className="exit-cont flex justify-center align-center">
                    <div className="exit-box">

                        <div className="flex justify-center">
                            <div className="lg">
                                <img src={sh_d_logo_nb} alt="" />
                            </div>
                        </div>

                        <h2>I think you've made a mistake.</h2>

                        <p>
                            Money is in front of you. <br />
                            It's not too late to comeback... up to you. <br />
                            Don't forget they love the rich men, not the 9-5ers.
                        </p>

                        <div className="flex justify-center">
                            <div className="gg1-box">
                                <img src={gg1} alt="" />
                            </div>
                        </div>

                        <div className="flex justify-center">
                            <div className="exit-btn flex justify-center align-center">
                                <a href="https://movepump.com/token/0x361b655145465f6a8113f9fdca0ad01ff19b4ec31e0f0bf7514dba47d8e766db::shub::SHUB" target="_blank">Make me rich !</a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="nfts" id="nfts">
                <div className="main-frame">
                    <div className="cs-header">
                        <h2>Future NFTs</h2>
                    </div>

                    <div className="nft-item-cont grid row grid-column-3 gap-20">

                        <div className="nft-item">
                            <div className="nft-item-image">
                                <img src={nft1} alt="" />
                            </div>
                            <div className="nft-item-desc">
                                <h2>AINA</h2>
                                <a href="#">I want</a>
                            </div>
                        </div>

                        <div className="nft-item">
                            <div className="nft-item-image">
                                <img src={nft2} className="cover" alt="" />
                            </div>
                            <div className="nft-item-desc">
                                <h2>SUIBRINA</h2>
                                <a href="#">I want</a>
                            </div>
                        </div>

                        <div className="nft-item">
                            <div className="nft-item-image">
                                <img src={nft3} alt="" />
                            </div>
                            <div className="nft-item-desc">
                                <h2>AIKIRA</h2>
                                <a href="#">I want</a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            

        </div>
    );
}
 
export default Home;